import { Injectable } from '@angular/core';
import {IconFont} from "../../enums/icon-font";
import {ItemActionElement} from "./item-action-element";

@Injectable({
  providedIn: 'root'
})
export class ItemActionService {

  constructor() { }

  generateItem(icon: IconFont, title: string, isActive: boolean, func: (...args: any[]) => any): ItemActionElement {
    return {
      icon,
      title,
      isActive,
      func
    }
  }
}
